import {
  ContentDetailCard,
  IconWrapper,
  getMediaBasePath,
  pxToRem,
  pxTovW,
  resourceTypeName,
} from '@geneo2-web/shared-ui';
import { Box, Typography } from '@mui/material';
import {
  ResourceCategoryEnum,
  Resource_ResourceEnum,
} from '@protos/content_management/content.db_pb';
import { AssignedResourceInfo } from '@protos/learning_management/lms.assessment.student.apis_pb';

interface IProps {
  resources: AssignedResourceInfo[];
  completedResourceIds: string[];
  // Undefined makes the list read-only.
  onOpen?: (resourceId: string) => void;
}

export default function AssignedResources(props: IProps) {
  const { resources, completedResourceIds, onOpen } = props;
  const completedCount = resources.filter((r) =>
    completedResourceIds.includes(r.resourceId)
  ).length;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: { xs: pxToRem(12), md: pxTovW(16) },
      }}
    >
      <Typography variant="h2">Assigned Resources</Typography>
      <Typography variant="bodyText" color="primary.main">
        {completedCount}/{resources.length} resources completed
      </Typography>
      {resources.map((resource) => {
        const done = completedResourceIds.includes(resource.resourceId);
        return (
          <Box
            key={resource.resourceId}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: pxToRem(10), md: pxTovW(12) },
            }}
          >
            <Box
              aria-label={done ? 'Completed' : 'Not completed'}
              sx={{
                width: { xs: pxToRem(28), md: pxTovW(36) },
                flexShrink: 0,
                textAlign: 'center',
              }}
            >
              {done ? (
                <IconWrapper
                  name="green-tick"
                  type="png"
                  parentFolder="icons"
                  size="md"
                />
              ) : (
                <Typography variant="h3" color="neutral.grey">
                  ○
                </Typography>
              )}
            </Box>
            <ContentDetailCard
              onClick={onOpen ? () => onOpen(resource.resourceId) : undefined}
              variant={'small'}
              image={getMediaBasePath(
                resource.posterImageUrl,
                resource.resourceCategoryType ===
                  ResourceCategoryEnum.RESOURCE_CATEGORY_MY_RESOURCES
                  ? 'userDataBucket'
                  : 'processedMediaBucket'
              )}
              heading={resource.title}
              iconDetails={[
                {
                  iconName: 'clock',
                  text: resource.estimatedTimeInMin.toString() + ' min',
                },
                {
                  iconName: resourceTypeName(resource.resourceType).icon,
                  text: resourceTypeName(resource.resourceType).name,
                },
              ]}
              showVideoIcon={
                resource.resourceType ===
                Resource_ResourceEnum.RESOURCE_TYPE_VIDEO
              }
              rootStyle={{
                width: { xs: '100%', md: pxTovW(600) },
                height: { xs: pxToRem(102), md: pxTovW(120) },
                cursor: onOpen ? 'pointer' : 'default',
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
}
